import React from 'react';
import styles  from './Applicators.module.scss';
import ApplicatorsGrid from "../../../components/ApplicatorsGrid/ApplicatorsGrid";
import EquipmentSpecifications from "../../../components/clinic/EquipmentSpecifications/EquipmentSpecifications";
import ProductFamily from "../../../components/clinic/ProductFamily/ProductFamily";

class ChainApplicatorsPage extends React.Component {
    render() {
        return (
            <div className={styles['container']}>
                <div className={styles['box']}>
                    <ApplicatorsGrid userType={3} />
                </div>

                <div className={styles['promotional-row']}>
                    <div className={styles['box']}>
                        <EquipmentSpecifications/>
                    </div>
                    <div className={styles['box']}>
                        <ProductFamily/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChainApplicatorsPage;

